import { colors } from '../../colors';
var para = {
  messageColor: colors.dirtyBlue
};
export default para;